import { useSelectionStore } from "@app/Store/selection-store";

export const useCustomerSelections = () => {
  const selectionStore = useSelectionStore();

  return {
    clearTicketChoices: selectionStore.clearTicketChoices,
    clearCustomerSelections: selectionStore.clearCustomerSelections,
    // TODO clear everything else
    // I gamla gjordes det hÃ¤r:
    // this.startDate = null;
    // this.arrivalDate = null;
    // this.returnArrivalDate = null;
    // this.returnDate = null;
    // this.route = new RouteViewModelBase();
    // this.returnTrip = false;
    // this.expressTrip = false;
    // this.startDateInPeakSeason = false;
    // this.chooseExactReturnDateLater = false;
    // this.boatDetails = new BoatDetails();
    // this.products = [];
    // this.addedToCart = {};
    // this.frequencyType = 0;
    // this.returnFrequencyType = 0;
    // this.recurringTrip = false;
    // this.selectedDays = [] as number[];
    // this.selectedReturnDays = [] as number[];
  };
};
